import { Redux } from '../..'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { GygEonMasterAction } from '@/src/types/apps/gygEonMasterActions'
import { GygQueryOptions } from '@/src/views/components/master-pricing-list/types'

interface EonMasterActionInitialState {
  masterActions: GygEonMasterAction[]
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: EonMasterActionInitialState = {
  masterActions: [],
  loading: false,
  success: null,
  error: null
}

export interface GygEonMasterActionPayload {
  restaurantId: number
  auvAction1Id: number
  auvAction2Id: number
  auvAction3Id: number
  fourWallAction1Id: number
  fourWallAction2Id: number
  fourWallAction3Id: number
  salesTarget: number
  labourPct: number
  inStoreAvgCheck: number
  splh: number
  miam: number
}

interface EonMasterActionResponse {
  data: GygEonMasterAction[]
}

export const getEonMasterActions = createAsyncThunk<EonMasterActionResponse, GygQueryOptions, Redux>(
  'gygEonMasterAction/getEonMasterActions',
  async (queryOptions, { extra }) => {
    const { data: responseData } = await extra.httpClient.get(`eon-master-actions`, {
      params: queryOptions
    })

    return responseData
  }
)

const gygEonMasterActionSlice = createSlice({
  name: 'getAllEonMasterAction',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getEonMasterActions.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getEonMasterActions.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.masterActions = action.payload.data
      })
      .addCase(getEonMasterActions.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch eon master actions'
      })
  }
})

export default gygEonMasterActionSlice.reducer
